var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountsStatsSection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4brkbqhf7a",
    d: "M0 0h12.812v7.13H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2ix4tnf4ac",
    d: "M0 0h8.22v7.918H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.488 11.915)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kju0i8tc9b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4brkbqhf7a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.747 6.967c-.427-.755-.708-1.556-.74-2.416-.036-.959-.026-1.92-.027-2.879 0-.14-.048-.225-.163-.308C9.47-.33 6.027-.463 3.551 1.059 1.585 2.266.48 4.014.1 6.208c-.053.306-.069.619-.101.923h12.797c.011-.03.017-.038.015-.042a2.865 2.865 0 0 0-.065-.122",
    fill: "#4F42B5",
    mask: "url(#kju0i8tc9b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.038 15.54c-.82.643-1.64 1.284-2.463 1.924-.231.18-.383.166-.578-.053-.34-.377-.677-.757-1.012-1.137-.167-.19-.164-.392 0-.52.156-.124.355-.093.518.089.281.312.558.626.846.95l1.582-1.235c.222-.174.443-.35.666-.522.209-.162.403-.163.542-.007.136.155.1.353-.101.51m1.721-2.04c0-.062-.076-.149-.14-.182-1.187-.618-2.379-1.228-3.568-1.844-.11-.056-.193-.053-.3.005-1.145.61-2.292 1.218-3.441 1.82-.117.062-.164.127-.162.258.01.467.004.933.004 1.4 0 .362-.011.724.003 1.085.08 2.16 1.122 3.742 3.11 4.739.595.297.603.283 1.218.02.025-.011.05-.02.075-.032 1.878-.896 2.977-2.338 3.165-4.352.09-.966.036-1.944.036-2.917",
    fill: "#6662C2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.818 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cg9c06208d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2ix4tnf4ac"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.11 7.918c2.27 0 4.11-1.772 4.11-3.959C8.22 1.773 6.38 0 4.11 0 1.84 0 0 1.773 0 3.96c0 2.186 1.84 3.958 4.11 3.958",
    fill: "#4F42B5",
    mask: "url(#cg9c06208d)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsStatsSection);
export default __webpack_public_path__ + "static/media/accounts-stats-section.de8ecf51a3f1651bd4c130acf03d592c.svg";
export { ForwardRef as ReactComponent };